import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { OverTimeUnsegmentedVizExternalProps } from '../../types';
import {
  OverTimeUnsegmentedLineChartActions,
  OverTimeUnsegmentedLineChartState,
} from './types';

export const useOverTimeUnsegmentedLineChartStateManager = (
  externalProps: OverTimeUnsegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  OverTimeUnsegmentedLineChartState,
  OverTimeUnsegmentedLineChartActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: false,
      enableStack: false,
      enableLabels: true,
      enableLegend: true,
      enableSortOrder: true,
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
